import React, {useEffect} from 'react';
import {Row, Col} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {MainLoader, DataGrid} from '@components';
import {StyledH3, WhiteButton} from '@styled';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
// import {useHistory} from 'react-router-dom';
import {sagaActions} from './redux/saga';

const StyledSubTableHead = styled.div`
  color: #00000091;
`;

const RowActions = ({data, viewStructure, expandedRows}) => {
  const isShowingDetails = expandedRows.find((item) => item === data.id)
    ? true
    : false;
  return (
    <div>
      {/* <WhiteButton style={{margin: '.16em'}}>View Details</WhiteButton> */}
      <WhiteButton
        onClick={() => viewStructure(data)}
        style={{margin: '.16em'}}
      >
        <i
          className={`fa ${!isShowingDetails ? 'fa-eye' : 'fa-eye-slash'} mr-1`}
        />
        Details
      </WhiteButton>
    </div>
  );
};

const Facility = ({entity}) => {
  const [isViewDetails, toggleViewDetails] = React.useState(false);
  return (
    <div
      style={
        isViewDetails
          ? {backgroundColor: '#fff', border: '1px dashed #ccc'}
          : {}
      }
      className="px-1"
    >
      <Row className="my-1">
        <Col>{entity.id}</Col>
        <Col>{entity.name}</Col>
        <Col>{entity.entityStatus}</Col>
        <Col>{entity.relationToParent}</Col>
        <Col>{entity.status}</Col>
        <Col>
          <WhiteButton onClick={() => toggleViewDetails(!isViewDetails)}>
            <i
              className={`fa ${
                !isViewDetails ? 'fa-eye' : 'fa-eye-slash'
              } mr-1`}
            />{' '}
            Details
          </WhiteButton>
        </Col>
      </Row>
      <div style={{display: isViewDetails ? '' : 'none'}} className="px-3 pb-3">
        <hr />
        <Row noGutters>
          <Col>
            <StyledSubTableHead>Address1</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Address2</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Address3</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>City</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Country</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Postal Code</StyledSubTableHead>
          </Col>
        </Row>
        <Row noGutters>
          <Col>{entity.address1 || '-'}</Col>
          <Col>{entity.address2 || '-'}</Col>
          <Col>{entity.address3 || '-'}</Col>
          <Col>{entity.city || '-'}</Col>
          <Col>{entity.country || '-'}</Col>
          <Col>{entity.postalCode || '-'}</Col>
        </Row>
      </div>
    </div>
  );
};

const Subsidiary = ({entity, data}) => {
  const [isViewDetails, toggleViewDetails] = React.useState(false);

  const facilities = data.subEntities.filter(
    (subFac) => subFac.parentEntity === entity.id
  );

  return (
    <div
      style={
        isViewDetails
          ? {backgroundColor: '#fff', border: '1px dashed #ccc'}
          : {}
      }
      className="px-1"
    >
      <Row className="my-1">
        <Col>{entity.id}</Col>
        <Col>{entity.name}</Col>
        <Col>{entity.entityStatus}</Col>
        <Col>{entity.relationToParent}</Col>
        <Col>{entity.status}</Col>
        <Col>
          <WhiteButton onClick={() => toggleViewDetails(!isViewDetails)}>
            <i
              className={`fa ${
                !isViewDetails ? 'fa-eye' : 'fa-eye-slash'
              } mr-1`}
            />{' '}
            Details
          </WhiteButton>
        </Col>
      </Row>
      <div style={{display: isViewDetails ? '' : 'none'}} className="px-3 pb-3">
        <hr />
        <Row noGutters>
          <Col>
            <StyledSubTableHead>Address1</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Address2</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Address3</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>City</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Country</StyledSubTableHead>
          </Col>
          <Col>
            <StyledSubTableHead>Postal Code</StyledSubTableHead>
          </Col>
        </Row>
        <Row noGutters>
          <Col>{entity.address1 || '-'}</Col>
          <Col>{entity.address2 || '-'}</Col>
          <Col>{entity.address3 || '-'}</Col>
          <Col>{entity.city || '-'}</Col>
          <Col>{entity.country || '-'}</Col>
          <Col>{entity.postalCode || '-'}</Col>
        </Row>
        <Row noGutters>
          <Col>
            <hr />
            <div className="text-muted font-weight-bold">
              Subsidiary Facilities:
            </div>
            <div className="mx-2">
              {facilities.length ? (
                <>
                  <Row className="mb-1">
                    <Col>
                      <StyledSubTableHead>#</StyledSubTableHead>
                    </Col>
                    <Col>
                      <StyledSubTableHead>Facility Name</StyledSubTableHead>
                    </Col>
                    <Col>
                      <StyledSubTableHead>Entity Status</StyledSubTableHead>
                    </Col>
                    <Col>
                      <StyledSubTableHead>
                        Relationship To Parent
                      </StyledSubTableHead>
                    </Col>
                    <Col>
                      <StyledSubTableHead>Status</StyledSubTableHead>
                    </Col>
                    <Col>
                      <StyledSubTableHead> </StyledSubTableHead>
                    </Col>
                  </Row>
                  {facilities.map((subEntity) => (
                    <Facility
                      key={`entity-r-${subEntity.id}`}
                      entity={subEntity}
                    />
                  ))}
                </>
              ) : (
                <div>No facility added yet!</div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const EntityController = ({data}) => {
  const facilities = data.entities.filter(
    (entity) => entity.type === 'Facility'
  );
  const subsidiaries = data.entities.filter(
    (entity) => entity.type === 'Subsidiary'
  );
  return (
    <div className="p-3">
      <div className="text-muted font-weight-bold">Facilities:</div>
      <div className="mx-2">
        {facilities.length ? (
          <>
            <Row className="mb-1">
              <Col>
                <StyledSubTableHead>#</StyledSubTableHead>
              </Col>
              <Col>
                <StyledSubTableHead>Facility Name</StyledSubTableHead>
              </Col>
              <Col>
                <StyledSubTableHead>Entity Status</StyledSubTableHead>
              </Col>
              <Col>
                <StyledSubTableHead>Relationship To Parent</StyledSubTableHead>
              </Col>
              <Col>
                <StyledSubTableHead>Status</StyledSubTableHead>
              </Col>
              <Col>
                <StyledSubTableHead> </StyledSubTableHead>
              </Col>
            </Row>
            {facilities.map((entity) => (
              <Facility key={`entity-r-${entity.id}`} entity={entity} />
            ))}
          </>
        ) : (
          <div>No facility added yet!</div>
        )}
        <hr />
      </div>
      <div className="text-muted font-weight-bold">Subsidiaries:</div>
      {subsidiaries.length ? (
        <>
          <Row className="mb-1">
            <Col>
              <StyledSubTableHead>#</StyledSubTableHead>
            </Col>
            <Col>
              <StyledSubTableHead>Subsidiary Name</StyledSubTableHead>
            </Col>
            <Col>
              <StyledSubTableHead>Entity Status</StyledSubTableHead>
            </Col>
            <Col>
              <StyledSubTableHead>Relationship To Parent</StyledSubTableHead>
            </Col>
            <Col>
              <StyledSubTableHead>Status</StyledSubTableHead>
            </Col>
            <Col>
              <StyledSubTableHead> </StyledSubTableHead>
            </Col>
          </Row>
          {subsidiaries.map((entity) => (
            <Subsidiary
              key={`entity-r-${entity.id}`}
              entity={entity}
              data={data}
            />
          ))}
        </>
      ) : (
        <div className="ml-2">No subsidiary added yet!</div>
      )}
    </div>
  );
};

const OwnerCorporateStructure = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const corporateData = useSelector((state) => state.corporate.ownerCorporate);
  const isLoading = useSelector(
    (state) => state.corporate.ownerCorporate.loading
  );

  const [expandedRows, setExpandedRows] = React.useState([]);

  const [pagination, setPagination] = React.useState({
    page: 1,
    pageSize: 20,
    totalCount: 0,
    sortOn: 'createdBy',
    sortDir: 'DESC',
  });

  useEffect(() => {
    if (
      corporateData.page !== pagination.page ||
      corporateData.pageSize !== pagination.pageSize ||
      corporateData.totalCount !== pagination.totalCount ||
      corporateData.sortOn !== pagination.sortOn ||
      corporateData.sortDir !== pagination.sortDir
    ) {
      setPagination({
        page: corporateData.page,
        pageSize: corporateData.pageSize,
        totalCount: corporateData.totalCount,
        sortOn: corporateData.sortOn,
        sortDir: corporateData.sortDir,
      });
    }
  }, [corporateData]);

  const fetchData = ({
    page = 1,
    pageSize = pagination.pageSize,
    sortOn,
    sortDir,
  }) => {
    dispatch({
      type: sagaActions.FETCH_OWNER_CORPORATE_LIST,
      payload: {
        values: {
          page,
          pageSize,
          sortOn,
          sortDir,
        },
      },
    });
  };

  useEffect(() => {
    fetchData({});
  }, []);

  const handleViewStructure = React.useCallback(
    (data) => {
      // toggle expand row
      let filteredRows = [...expandedRows];
      const found = filteredRows.find((eRow) => eRow === data.id);
      if (found) {
        filteredRows = filteredRows.filter((eRow) => eRow !== data.id);
      } else {
        filteredRows.push(data.id);
      }
      setExpandedRows(filteredRows);
    },
    [expandedRows]
  );

  const renderRowActions = (colProps) => {
    return (
      <RowActions
        data={colProps}
        viewStructure={handleViewStructure}
        expandedRows={expandedRows}
      />
    );
  };

  const Columns = React.useMemo(
    () => [
      {
        accessor: 'id',
        Header: '#',
        className: 'grey-column d-none d-lg-block',
        width: 50,
        tooltip: false,
      },
      {
        accessor: 'name',
        Header: 'Corporate Name',
        tooltip: false,
        className: 'd-none d-lg-block',
      },
      {
        accessor: 'status',
        Header: 'Status',
        tooltip: false,
        className: 'd-none d-lg-block',
      },
      {
        accessor: 'createdBy',
        Header: 'Created By',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({row}) => row.original.createdByUser,
      },
      {
        accessor: 'createdOn',
        Header: 'Created On',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({value}) => (value ? moment(value).fromNow() : ''),
      },
      {
        id: 'actions',
        Header: <div className="d-none d-lg-block">Actions</div>,
        accessor: renderRowActions,
        disableSortBy: true,
        disableFilters: true,
        width: 50,
      },
    ],
    [pagination, expandedRows]
  );

  const renderExpandedRow = (row) => {
    return <EntityController data={row.original} />;
  };

  return (
    <>
      {isLoading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <div>
        <StyledH3>{t('owner.corporateStructure.pageHeading')}</StyledH3>
        <DataGrid
          columns={Columns}
          data={corporateData.data}
          onFetchData={fetchData}
          pagination={pagination}
          filtering={false}
          expandEnabled
          expandedRows={expandedRows}
          expandRowId="id"
          expandedRowRender={renderExpandedRow}
        />
      </div>
    </>
  );
};

// const OwnerCorporateStructure = () => {
//   return <div>OwnerCorporateStructure</div>;
// };
export default OwnerCorporateStructure;
